import ParabolaAnim from "./parabola_anim";

const { ccclass, property, menu } = cc._decorator;

@ccclass
@menu("custom/bipai/BiPaiSeatBombView")
export default class BiPaiSeatBombView extends cc.Component{
   
    @property(cc.Node)
    nodeFromPos: cc.Node = null

    @property(cc.Node)
    nodeBombAnimPrefab: cc.Node = null

    @property(cc.Node)
    nodeBombParent: cc.Node = null

    @property(ParabolaAnim)
    parabolaAnim: ParabolaAnim = null

    protected m_nodeBomb: cc.Node = null
    protected m_parabolaAnim: ParabolaAnim = null

    protected ensureInitedNode(node: cc.Node, prefab: cc.Node, parent: cc.Node): cc.Node{
        let newNode = node || cc.instantiate(prefab)
        newNode.parent = parent
        newNode.position = cc.Vec2.ZERO
        return newNode
     }

    playBombFlyAnim(fromPos: cc.Vec2, dir: number, onFinish?: Function){
        let self = this

        if(!self.m_parabolaAnim){
            self.m_parabolaAnim = self.ensureInitedNode(null, self.parabolaAnim.node, self.nodeBombParent).getComponent(ParabolaAnim)
        }   
        let duration = 1
        let fromLocalPos = self.m_parabolaAnim.node.parent.convertToNodeSpaceAR(fromPos)
        let toLocalPos = cc.Vec2.ZERO
        self.m_parabolaAnim.playFromToAnim(fromLocalPos, toLocalPos, duration, onFinish) 
        let node = self.m_parabolaAnim.node 
        let rotAnim = cc.rotateBy(duration, 360 * dir)  
        let tmpFun = function(){
            node.active = false
            self.setNodeActionCallback(node, null)
            onFinish && onFinish()
        }.bind(self)
        let callFun = cc.callFunc(tmpFun)    
        self.checkAndDealCallback(node)
        node.active = true     
        self.setNodeActionCallback(node, tmpFun)
        var seq = cc.sequence([rotAnim, callFun])
        node.stopAllActions()
        node.runAction(seq) 
    }


    playBombAnim(delay?: number, onFinish?: Function){
        let self = this
        let deal_fun = function(){
            let nodeParent = self.nodeBombParent
            let node = cc.instantiate(self.nodeBombAnimPrefab)
            node.parent = nodeParent            
            node.position = cc.Vec2.ZERO
            node.active = true
            self.scheduleOnce(function(){
                node.destroy()
                onFinish && onFinish()
            }, 1.33)
        }
        if(delay){
            self.scheduleOnce(function(){
                deal_fun()
            }, delay)
        }else{
            deal_fun()
        }
    }

    protected checkAndDealCallback(node: cc.Node){
        let self = this
        let lastFun = self.getNodeActionCallback(node)            
        if(lastFun){            
            lastFun()
            return self.checkAndDealCallback(node)
        }  
    }

    protected setNodeActionCallback(node: cc.Node, callback: Function){
        node['_action_callback'] = callback
    }    

    protected getNodeActionCallback(node: cc.Node){
        return node['_action_callback']
    }
}
